// width/height attributes from a WP media item's mediaDetails, so browsers
// (and PageSpeed) know an image's aspect ratio before it loads. CSS still
// sizes the image; components set width/height: auto where they only cap it
// with max-width/max-height.
const imageSize = image => {
  const { width, height } = image?.mediaDetails ?? {}
  return width && height ? { width, height } : {}
}

export default imageSize
